import React, { useState, useEffect, useMemo } from "react";
import DataTable from "../components/DataTable.js";
import { fetchDataFromAPI, saveData, deleteData } from "../components/api.js";
import subscriptionStatus from "../components/SubscriptionStatus.js";
const getRangeInputProps = (col) => {
  if (col.type === "range") {
    return { min: 0, max: 5, step: 0.5 }; // Limit range inputs to 0-5 with step of 0.1
  }
  return {}; // Return empty object for non-range types
};
const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({ public_id: "" });
  const [sortField, setSortField] = useState(""); // Track the current sorted field
  const [sortOrder, setSortOrder] = useState("desc"); // Track the current sort order
  const [productsOptions, setProductsOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);

  const [shippingCompanyOptions, setShippingCompanyOptions] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [error, setError] = useState(null);
  const isSubscribed = subscriptionStatus();
  useEffect(() => {
    fetchData();
    console.log("referching data", currentPage, filters, sortField, sortOrder);
  }, [filters, sortField, sortOrder]);

  const fetchData = async (page = 1, itemsPerPage = 10, filters = {}) => {
    try {
      console.log("fetchData", filters, sortField, sortOrder);
      const token = localStorage.getItem("token");
      console.log("filters", filters);

      // Prepare query parameters

      // Dynamically construct query parameters, excluding empty sortField and sortOrder
      const filterParamsObj = {
        page,
        limit: 10,
        ...filters,
        includeDeleted: "false",
      };

      // Add sortField and sortOrder only if they are not empty
      if (sortField) {
        filterParamsObj.sortField = sortField;
      }
      if (sortOrder) {
        filterParamsObj.sortOrder = sortOrder;
      }
      console.log("Filter Params:", new URLSearchParams(filterParamsObj));

      // Create the query string
      const filterParams = new URLSearchParams(filterParamsObj).toString();

      // Fetch suppliers and materials concurrently
      const { data: orders, pagination } = await fetchDataFromAPI(
        `/api/orders`,
        filterParams,
        token
      );

      const { data: products } = await fetchDataFromAPI(
        `/api/products`,
        {},
        token
      );
      const { data: customers } = await fetchDataFromAPI(
        `/api/customers`,
        {},
        token
      );
      const { data: shippingCompanies } = await fetchDataFromAPI(
        `/api/shipping-companies`,
        {},
        token
      );
      // Update state
      setOrders(orders || []);
      setProductsOptions(products || []);
      setCustomerOptions(customers || []);
      setShippingCompanyOptions(shippingCompanies || []);
      setTotalPages(pagination?.totalPages || 1);

      console.log("Orders:", orders);
      console.log("Products:", products);
      console.log("Customers:", customers);
      console.log("shippingCompanies:", shippingCompanies);
    } catch (err) {
      console.error("Error fetching data:", err.message);
      setError(err.message);
    }
  };

  const handleAddRow = async () => {
    try {
      const newRow = {
        payment_status: "pending",

        status: "pending",
      };

      await saveData(`/api/orders`, newRow, "POST");
      fetchData();
    } catch (err) {
      console.error("Error adding row:", err);
    }
  };

  const handleEdit = async (id, updatedData) => {
    try {
      await saveData(`/api/orders/${id}`, updatedData);
      fetchData();
    } catch (err) {
      console.error("Error editing order:", err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteData(`/api/orders/${id}`);
      fetchData();
    } catch (err) {
      console.error("Error deleting order:", err);
    }
  };
  const handlePageChange = (newPage) => {
    console.log("Parent - Page changed to:", newPage); // Log in parent
    setCurrentPage(newPage); // Update the current page
    fetchData(newPage, 10); // Fetch new data
  };
  const handleSort = (field, order) => {
    console.log("handleSort,field,order", field, order);
    setSortField(field); // Update the sorted field
    setSortOrder(order); // Update the sort order (asc/desc)
  };
  const handleFilterChange = (newFilters) => {
    console.log("handleFilterChange", newFilters);
    setFilters(newFilters); // Update filters in the parent state
    fetchData(currentPage, newFilters); // Refetch data with new filters
  };
  const columns = [
    { header: "Public ID", accessor: "public_id" },
    {
      header: "Customer ",
      accessor: "customer_id",
      type: "dropdown",
      options: customerOptions.map((customer) => ({
        value: customer.id,
        label: customer.name,
      })),
    },
    { header: "Earning Amount", accessor: "earning_amount", type: "range" },
    { header: "Shipping Date", accessor: "shipping_date", type: "Date" },
    {
      header: "Products",
      accessor: "products",
      type: "list",
      options: productsOptions,
    },

    { header: "Total Amount", accessor: "total_amount", type: "range" },
    {
      header: "Status",
      accessor: "status",
      type: "dropdown", // Specify the column type
      options: [
        { value: "pending", label: "pending" },
        { value: "shipped", label: "shipped" },
        { value: "delivered", label: "delivered" },
        { value: "cancelled", label: "cancelled" },
      ],
    },
    { header: "Order Date", accessor: "order_date", type: "Date" },
    { header: "Shipping Address", accessor: "shipping_address" },
    { header: "Delivery Date", accessor: "delivery_date", type: "Date" },
    { header: "Profit", accessor: "profit", type: "range" },
    { header: "Discount", accessor: "discount", type: "range" },
    { header: "Tax Amount", accessor: "tax_amount", type: "range" },
    {
      header: "Shipping Company ",
      accessor: "shipping_company_name",
      type: "list",
      options: shippingCompanyOptions,
    },
    {
      header: "Payment Status",
      accessor: "payment_status",
      type: "dropdown", // Specify the column type
      options: [
        { value: "pending", label: "Pending" },
        { value: "paid", label: "Paid" },
        { value: "inactive", label: "Inactive" },
      ],
    },
  ];

  console.log("columns", columns);
  return (
    <div>
      {" "}
      <DataTable
        title="Orders"
        columns={columns}
        data={orders}
        currentPage={currentPage}
        setData={setOrders}
        totalPages={totalPages}
        onSort={handleSort}
        sortOrder={sortOrder}
        sortField={sortField}
        onPageChange={handlePageChange}
        filters={filters}
        onFilterChange={handleFilterChange}
        onAddRow={handleAddRow}
        actions={[
          {
            label: "Edit",
            onClick: (row) => {
              const updatedData = { ...row, name: "Updated Name" };
              handleEdit(row.id, updatedData);
            },
          },
          {
            label: "Delete",
            onClick: (row) => handleDelete(row.id),
          },
          {
            label: "Show Invoice",
            onClick: (row) => setSelectedOrderId(row.id),
          },
        ]}
        apiEndpoint="/api/orders"
        itemsPerPage={10}
        fetchData={fetchData}
        getRangeInputProps={getRangeInputProps}
        selectedItems={orders.products}
      />
      {selectedOrderId && (
        <Invoice
          orderId={selectedOrderId}
          onClose={() => setSelectedOrderId(null)}
        />
      )}
    </div>
  );
};

export default Orders;
